import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Paper,
} from "@mui/material";
const AttributeTable = ({ data, columns }) => {
  return (
    <TableContainer component={Paper}>
      <Table>
        <TableBody>
          {columns.map((column) => (
            <TableRow key={column.field}>
              <TableCell>{column.label}</TableCell>
              <TableCell>{data[column.field]}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default AttributeTable;
